import React from 'react';
import { useHistory } from 'react-router-dom';
import s from './Leads.module.scss';

const LeadRowActions = ({ lead, activeTab, onStatusChange }) => {
  const history = useHistory();
  const tab = activeTab === 'all' ? (lead.status || 'new') : activeTab;

  return (
    <div className={s.actionButtons}>
      {(tab === 'due' || tab === 'new') && (
        <>
          <button
            className={s.convertBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('convert', lead); }}
            title="Convert to Booking"
          >
            <i className="fa fa-rocket" />
            <span>Convert</span>
          </button>
          <button
            className={s.linkBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('link', lead); }}
            title="Link to an existing booking"
          >
            <i className="fa fa-link" />
            <span>Link</span>
          </button>
          <button
            className={s.followUpBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('follow_up', lead); }}
            title="Schedule Follow-up"
          >
            <i className="fa fa-clock-o" />
            <span>Follow up</span>
          </button>
          <button
            className={s.dropBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('drop', lead); }}
            title="Drop Lead"
          >
            <i className="fa fa-trash" />
            <span>Drop</span>
          </button>
        </>
      )}
      {tab === 'follow_up' && (
        <>
          <button
            className={s.convertBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('convert', lead); }}
            title="Convert to Booking"
          >
            <i className="fa fa-rocket" />
            <span>Convert</span>
          </button>
          <button
            className={s.linkBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('link', lead); }}
            title="Link to an existing booking"
          >
            <i className="fa fa-link" />
            <span>Link</span>
          </button>
          <button
            className={s.followUpBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('reschedule', lead); }}
            title="Reschedule Follow-up"
          >
            <i className="fa fa-clock-o" />
            <span>Reschedule</span>
          </button>
          <button
            className={s.resetBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('reset', lead); }}
            title="Reset to New"
          >
            <i className="fa fa-undo" />
            <span>Reset</span>
          </button>
          <button
            className={s.dropBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('drop', lead); }}
            title="Drop Lead"
          >
            <i className="fa fa-trash" />
            <span>Drop</span>
          </button>
        </>
      )}
      {tab === 'converted' && (
        <>
          {lead.converted_booking_id && (
            <button
              className={s.convertBtn}
              onClick={(e) => {
                e.stopPropagation();
                history.push(`/app/bookings?search=${lead.converted_booking_id}`);
              }}
              title="View Booking"
            >
              <i className="fa fa-external-link" />
              <span>Booking</span>
            </button>
          )}
          <button
            className={s.linkBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('link', lead); }}
            title={lead.converted_booking_id ? 'Change linked booking' : 'Link to an existing booking'}
          >
            <i className="fa fa-link" />
            <span>{lead.converted_booking_id ? 'Re-link' : 'Link'}</span>
          </button>
        </>
      )}
      {tab === 'dropped' && (
        <>
          <button
            className={s.linkBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('link', lead); }}
            title="Link this dropped lead to a booking (marks it Converted)"
          >
            <i className="fa fa-link" />
            <span>Link</span>
          </button>
          <button
            className={s.resetBtn}
            onClick={(e) => { e.stopPropagation(); onStatusChange('reset', lead); }}
            title="Reset to New"
          >
            <i className="fa fa-undo" />
            <span>Reset</span>
          </button>
        </>
      )}
    </div>
  );
};

export default LeadRowActions;
